module.exports = __webpack_public_path__ + "img/video-demo.3f9b0618.png";